import { render } from "./bigLoader.vue?vue&type=template&id=60d6c50b"
const script = {}

import exportComponent from "C:\\Users\\Leo\\Desktop\\RKPAYQR_SBER\\VtbSbp\\Front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QSpinnerAudio from 'quasar/src/components/spinner/QSpinnerAudio.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QPageContainer,QPage,QSpinnerAudio});
